// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useHistory } from "react-router"
import { IonButton } from "@ionic/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons"
import './SectionPageHeader.scss'


interface SectionPageHeaderProps {
  canGoBack?: boolean
  children?: React.ReactNode
  section?: string
  title?: string
  toolbar?: React.FC<{}>
}


const SectionPageHeader: React.FC<SectionPageHeaderProps> = ({
  canGoBack,
  children,
  section,
  title
}) => {
  const history = useHistory()
  const classNames: string[] = [
    "header",
    "section-header"
  ]
  if (!children && !title) {
    classNames.push("empty")
  }
  return (
    <div className={classNames.join(" ")}>
      {(!!section) ? (
        <div className="section-heading">
          <h2>{section}</h2>
        </div>
      ) : null}
      <div className="backbutton">
        {(!!canGoBack) ? (
          <IonButton
            fill="clear"
            onClick={() => history.goBack()}
          >
            <FontAwesomeIcon icon={faArrowLeft}/>
          </IonButton>
        ) : null}
      </div>
      {(!!title) ? (
        <div className="title">{title}</div>
      ) : null}
      <div className="section-toolbar">
        {children}
      </div>
    </div>
  )
}


export default SectionPageHeader